import "core-js/modules/es.object.define-property";
import "core-js/modules/es.object.to-string";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Component, Vue, Watch } from 'vue-property-decorator';
import { loading } from '@/decorators';
import SelectAddress from './selectAddress/index.vue';
import AddSubject from './addSubject/index.vue';
import Certification from './certification/index.vue';
import Audit from './audit/index.vue';
import SignUp from './signUp/index.vue';

var CertificationPage = function (_super) {
  __extends(CertificationPage, _super);

  function CertificationPage() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.current = _this.$enum.mine.CertificationSteps.SELECT_REGION;
    _this.status = 1;
    _this.loading = false;
    _this.data = {
      status: _this.$enum.mine.CustomerStartupStatusEnum.SELECT_REGION,
      selected_region: _this.$enum.mine.SelectedRegion.Mainland,
      sign_body_info: {
        account_code: '',
        sign_body_status: _this.$enum.mine.SignBodyStatusEnum.AUDITING,
        sign_body_name: '',
        register_area_code: '',
        credit_code: '',
        company_address: '',
        contact_name: '',
        email: '',
        finance_email: '',
        phone_number: '',
        business_license: '',
        business_license_url: '',
        tax_registration_certificate: '',
        tax_registration_certificate_url: '',
        type: String(_this.$enum.mine.CertificationTypeEnum.ORGANIZATION),
        postcode: '',
        province_name: '',
        province_code: '',
        province_id: '',
        city_name: '',
        city_code: '',
        city_id: ''
      },
      certification_info: {
        account_code: '',
        certification_type: _this.$enum.mine.CertificationTypeEnum.ORGANIZATION,
        name: '',
        phone_number: '',
        id_card_type: _this.$enum.mine.IdCardTypeEnum.ID_CARD,
        id_card_number: '',
        company_name: '',
        credit_code: '',
        is_agent: _this.$enum.mine.IsAgentEnum.NO,
        agent_name: '',
        agent_phone_number: '',
        agent_id_card_type: _this.$enum.mine.AgentIdCardTypeEnum.ID_CARD,
        agent_id_card_number: ''
      },
      firm_list: []
    };
    return _this;
  }

  CertificationPage.prototype.onRegisterAreaChange = function (data) {
    console.log(data);
    var value = data.sign_body_info ? data.sign_body_info.register_area_code : this.$enum.mine.RegisterAreaCodeEnum.CN;

    if (value === this.$enum.mine.RegisterAreaCodeEnum.CN) {
      this.$set(this.data, 'selected_region', this.$enum.mine.SelectedRegion.Mainland);
    } else {
      this.$set(this.data, 'selected_region', this.$enum.mine.SelectedRegion.NoMainland);
    }
  };

  Object.defineProperty(CertificationPage.prototype, "componentName", {
    get: function get() {
      if (this.data.selected_region === this.$enum.mine.SelectedRegion.Mainland) {
        switch (this.data.status) {
          case this.$enum.mine.CustomerStartupStatusEnum.ACTIVE:
            this.$router.push('/');
            return '';
            break;

          case this.$enum.mine.CustomerStartupStatusEnum.SELECT_REGION:
            this.current = this.$enum.mine.CertificationSteps.SELECT_REGION;
            return 'select-address';

          case this.$enum.mine.CustomerStartupStatusEnum.FILL_SIGN_BODY_FORM:
            this.current = this.$enum.mine.CertificationSteps.FILL_SIGN_BODY_FORM;
            return 'add-subject';

          case this.$enum.mine.CustomerStartupStatusEnum.FILL_CERTIFICATION_FORM:
            this.current = this.$enum.mine.CertificationSteps.FILL_CERTIFICATION_FORM;
            return 'certification';

          case this.$enum.mine.CustomerStartupStatusEnum.AUDIT_PENDING:
            this.current = this.$enum.mine.CertificationSteps.AUDIT_PENDING;
            return 'audit';

          case this.$enum.mine.CustomerStartupStatusEnum.SIGN_CONTRACT:
            this.current = this.$enum.mine.CertificationSteps.SIGN_CONTRACT;
            return 'sign-up';

          default:
            this.current = this.$enum.mine.CertificationSteps.SELECT_REGION;
            return 'select-address';
        }
      } else {
        switch (this.data.status) {
          case this.$enum.mine.CustomerStartupStatusEnum.ACTIVE:
            this.$router.push('/');
            return 'select-address';
            break;

          case this.$enum.mine.CustomerStartupStatusEnum.SELECT_REGION:
            this.current = this.$enum.mine.CertificationSteps.SELECT_REGION;
            return 'select-address';

          case this.$enum.mine.CustomerStartupStatusEnum.FILL_SIGN_BODY_FORM:
            this.current = this.$enum.mine.CertificationSteps.FILL_SIGN_BODY_FORM;
            return 'add-subject';

          case this.$enum.mine.CustomerStartupStatusEnum.FILL_CERTIFICATION_FORM:
            this.current = this.$enum.mine.CertificationSteps.FILL_CERTIFICATION_FORM;
            return 'certification';

          case this.$enum.mine.CustomerStartupStatusEnum.AUDIT_PENDING:
            this.current = this.$enum.mine.CertificationSteps.AUDIT_PENDING;
            return 'audit';

          case this.$enum.mine.CustomerStartupStatusEnum.SIGN_CONTRACT:
            this.current = this.$enum.mine.CertificationSteps.AUDIT_PENDING;
            return 'sign-up';

          default:
            this.current = this.$enum.mine.CertificationSteps.SELECT_REGION;
            return 'select-address';
        }
      }
    },
    enumerable: false,
    configurable: true
  });

  CertificationPage.prototype.queryStartupInfo = function () {
    return __awaiter(this, void 0, Promise, function () {
      var res;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.certification.queryStartupInfo()];

          case 1:
            res = _a.sent();

            if (res.code === 0) {
              return [2, res.data];
            } else {
              return [2, null];
            }

            return [2];
        }
      });
    });
  };

  CertificationPage.prototype.handleSubmit = function (data) {
    Object.assign(this.data, data);
  };

  CertificationPage.prototype.created = function () {
    return __awaiter(this, void 0, Promise, function () {
      var status, data, newData, key;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            status = this.$route.query.status;

            if (status) {
              this.data.status = status;
            }

            return [4, this.queryStartupInfo()];

          case 1:
            data = _a.sent();
            newData = this.$util.deepCopy(this.data);

            if (data) {
              for (key in this.data) {
                if (data[key]) {
                  newData[key] = data[key];
                }
              }
            }

            this.data = newData;
            return [2];
        }
      });
    });
  };

  __decorate([Watch('data', {
    immediate: true
  })], CertificationPage.prototype, "onRegisterAreaChange", null);

  __decorate([loading('loading')], CertificationPage.prototype, "queryStartupInfo", null);

  CertificationPage = __decorate([Component({
    components: {
      SelectAddress: SelectAddress,
      AddSubject: AddSubject,
      Certification: Certification,
      SignUp: SignUp,
      Audit: Audit
    }
  })], CertificationPage);
  return CertificationPage;
}(Vue);

export default CertificationPage;